import React, { useState, useContext } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Collapse,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import { BuildingContext } from "Context/BuildingProvider";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import TableLoading from "components/Misc/TableLoading";
import ErrorMessage from "components/Misc/ErrorMessage";
import { EditOutlined } from "@material-ui/icons";
import { GET_LOGBOOKS } from "lib/logbooks";
import { GetLogbooksQueryResult, Logbook } from "generated/graphql";

export default function LogbooksTable() {
  const history = useHistory();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const { loading, error, data }: GetLogbooksQueryResult = useQuery(
    GET_LOGBOOKS,
    {
      variables: {
        limit,
        offset: page,
      },
    }
  );

  const handleEditClick = (id: string) => {};

  const handleLimitChange = (event: any) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event: any, newPage: any) => {
    setPage(newPage);
  };
  if (loading) {
    return <TableLoading />;
  } else if (error) {
    return <ErrorMessage message={error.message}></ErrorMessage>;
  } else if (!!data?.Logbook) {
    return (
      <React.Fragment>
        <Paper className="container">
          <PerfectScrollbar>
            <Box>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    <TableCell>Time Type</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Created At</TableCell>
                    <TableCell>Updated At</TableCell>
                    <TableCell>Edit</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.Logbook.slice(0, limit).map((logbook) => (
                    <TableRow hover key={logbook.Id}>
                      <TableCell component="th" scope="row">
                        {logbook.logbookTitle}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {logbook.logbookTimeType}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {logbook.logbookType}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {logbook.created_at}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {logbook.updated_at}
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => {
                            handleEditClick(logbook.Id);
                          }}
                        >
                          <EditOutlined />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          <TablePagination
            component="div"
            count={
              data.Logbook_aggregate.aggregate?.count
                ? data.Logbook_aggregate.aggregate?.count
                : 0
            }
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Paper>
      </React.Fragment>
    );
  } else {
    return <div>No Logbooks</div>;
  }
}
